import { createFileRoute } from "@tanstack/react-router"
import CreateOrUpdatePurchaseOrder from "~/components/purchaseOrder/CreateOrUpdatePurchaseOrder"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute("/_auth/procurement/purchase-orders/create")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Purchase Order")
  return <CreateOrUpdatePurchaseOrder />
}
